import Styles from './InstagramPost.module.scss'
import { Skin } from '../Skin'
import { SkinProps } from '../Types'

const InstagramPost = ({ children, maxCharacterCount }: SkinProps) => {
  return (
    <Skin.Root className={Styles.instagramPost} data-testid="instagram-frame-skin">
      {children}
      <Skin.CaptionBelow lines={3} maxCharacterCount={maxCharacterCount} />
    </Skin.Root>
  )
}

export { InstagramPost }
